var _path, _path2, _circle, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9176 34.9348L19.6486 35.2038L21.8797 37.4348H11H8.5V34.9348V32.6592C8.5 31.0023 9.84315 29.6592 11.5 29.6592H25.1932L22.6932 32.1592H11.5C11.2239 32.1592 11 32.383 11 32.6592V34.9348H19.9176Z",
    fill: "#08141E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2639 35.2031L49.4622 6.00478C50.1456 5.32137 51.2537 5.32137 51.9371 6.00478L69.6871 23.7548C70.3705 24.4382 70.3705 25.5463 69.6871 26.2297L59.6896 36.2271C59.3615 36.5553 58.9163 36.7397 58.4522 36.7397L41.2268 36.7397L21.8004 36.7397L20.2639 35.2031Z",
    stroke: "#08141E",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5921,
    cy: 22.248,
    r: 3.97068,
    transform: "rotate(-45 46.5921 22.248)",
    fill: "#08141E",
    stroke: "#08141E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0367 23.7054C59.726 24.3946 60.0093 25.5674 59.6628 27.0965C59.3196 28.6107 58.3783 30.3226 56.8762 31.8247C55.3741 33.3268 53.6622 34.2681 52.1481 34.6113C50.6189 34.9578 49.4461 34.6745 48.7569 33.9852C48.0677 33.296 47.7843 32.1232 48.1309 30.5941C48.474 29.0799 49.4153 27.3681 50.9174 25.8659C52.4196 24.3638 54.1314 23.4225 55.6456 23.0794C57.1747 22.7328 58.3475 23.0162 59.0367 23.7054Z",
    fill: "#08141E",
    stroke: "#08141E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 36.4629H61.0399C62.0064 36.4629 62.7899 37.2464 62.7899 38.2129V67.7584C62.7899 68.7249 62.0064 69.5084 61.0399 69.5084H11.5C10.5335 69.5084 9.75 68.7249 9.75 67.7584V36.4629Z",
    stroke: "#08141E",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9745 75.4646C52.9745 75.4646 52.9745 75.4646 52.9745 75.4646C52.9745 75.4647 52.9744 75.4647 52.9744 75.4646L39.762 62.3666C38.1835 60.8018 38.1835 58.2502 39.762 56.6854C41.3212 55.1397 43.8348 55.1397 45.394 56.6854L52.4834 63.7134C54.0426 65.2592 56.5563 65.2592 58.1156 63.7134L74.766 47.2071C76.3252 45.6614 78.8388 45.6614 80.398 47.2071C81.9765 48.7719 81.9765 51.3235 80.398 52.8883L56.4595 76.6196C55.8172 77.2563 54.7818 77.2563 54.1395 76.6196L52.9745 75.4646Z",
    fill: "url(#paint0_radial_4742_71616)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4742_71616",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7495 51.3511) rotate(37.4911) scale(48.9738 47.3878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FFF69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#2FFFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bedbaba332d82dfea0e7e1395eeabe2c.svg";
export { ForwardRef as ReactComponent };